// app/javascript/controllers/modal_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel"]

  open() {
    this.overlayTarget.classList.remove("hidden")

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.overlayTarget.dataset.open = "true"
        this.panelTarget.dataset.open = "true"
      })
    })
  }

  close() {
    delete this.overlayTarget.dataset.open
    delete this.panelTarget.dataset.open

    setTimeout(() => {
      this.overlayTarget.classList.add("hidden")
    }, 450)
  }

  closeBackground(e) {
  // 背景クリックで閉じる
  if (e.target === this.overlayTarget) {
    this.close()
  }
  }
}
